import { T } from "services/lang/LanguageService";
import { Condition } from "../scadaTypes";

export const IMAGE_UPLOAD_URL = "/EASAS/rest/images/upload";

export const numberConditions: Condition[] = [
  { label: T("op.greater-than"), value: "gt" },
  { label: T("op.less-than"), value: "lt" },
  { label: T("op.greater-than-or-equals"), value: "gte" },
  { label: T("op.less-than-or-equals"), value: "lte" },
  { label: T("op.equals"), value: "eq" },
  { label: T("op.not-equals"), value: "neq" },
];
